import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=bf2cfe70&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf2cfe70')) {
      api.createRecord('bf2cfe70', component.options)
    } else {
      api.reload('bf2cfe70', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=bf2cfe70&", function () {
      api.rerender('bf2cfe70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Sped/Competencia/Page.vue"
export default component.exports